import OrgStructure from "../../Pages/Application/OrgStructure";
import OrgStructureUser from "../../Pages/Application/OrgStructureUser";
import UserGroups from "../../Pages/Application/UserGroups";
import Organization from "../../Pages/Organization/Organization";
import OrgScopedLayout from "../../Pages/Organization/OrgScopedLayout";
import OrgThemeEditor from "../../Pages/Themes/OrgTheme/OrgThemeEditor";
import OrgThemeSection from "../../Pages/Themes/OrgTheme/OrgThemeSection";
import { applicationRoutes } from "./applicationRoutes";
import { ORG_ROUTE_SEGMENTS } from "../routesConstant";
import UserRoles from "../../Pages/Application/Roles/UserRoles";
import MonitorLogs from "../../Pages/Monitor/MonitorLogs";

export const organizationRoutes = [
  {
    index: true,
    element: <Organization />
  },
  {
    path: ORG_ROUTE_SEGMENTS.ORG_ID_PARAM,
    element: <OrgScopedLayout />,
    children: [
      {
        path: ORG_ROUTE_SEGMENTS.GROUP_USERS,
        element: <UserGroups />
      },
      {
        path: ORG_ROUTE_SEGMENTS.STRUCTURE,
        element: <OrgStructure />
      },
      {
        path: ORG_ROUTE_SEGMENTS.USERS,
        element: <OrgStructureUser />
      },
      {
        path: ORG_ROUTE_SEGMENTS.THEME,
        children: [
          {
            index: true,
            element: <OrgThemeSection />
          },
          {
            path: ORG_ROUTE_SEGMENTS.THEME_ID_PARAM,
            element: <OrgThemeEditor />
          }
        ]
      },
      {
        path: ORG_ROUTE_SEGMENTS.APPLICATIONS,
        children: applicationRoutes
      },
      {
        path: ORG_ROUTE_SEGMENTS.ROLES,
        element: <UserRoles />
      },
      {
        path: ORG_ROUTE_SEGMENTS.MONITOR,
        element: <MonitorLogs />
      }
    ]
  }
];
